import { render, staticRenderFns } from "./ResourceInsert.vue?vue&type=template&id=88c06ed2&scoped=true&"
import script from "./ResourceInsert.vue?vue&type=script&lang=js&"
export * from "./ResourceInsert.vue?vue&type=script&lang=js&"
import style0 from "./ResourceInsert.vue?vue&type=style&index=0&id=88c06ed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c06ed2",
  null
  
)

export default component.exports